import { omit } from 'lodash-es'

export function useAttrsWithout(...args: Array<string>) {
  const attrs = useAttrs()
  return reactiveComputed<typeof attrs>(() => omit(attrs, ...args))
}
